var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesktopMobileApp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188 56C188 53.7909 186.209 52 184 52H54C51.7909 52 50 53.7909 50 56V81.3C50 83.5091 51.7909 85.3 54 85.3H88.3606V144C88.3606 146.209 90.1515 148 92.3606 148H184C186.209 148 188 146.209 188 144V56ZM180 60V140H96.3606V81.3C96.3606 79.0909 94.5698 77.3 92.3606 77.3H58V60H180Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208 36C208 33.7909 206.209 32 204 32H34C31.7909 32 30 33.7909 30 36V88H38V40H200V160H92V168H216C216 172.418 212.418 176 208 176H92V184H208C216.837 184 224 176.837 224 168V164C224 161.791 222.209 160 220 160H208V36Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 56H184V144H92.3606V81.3H54V56ZM172 64H152C149.791 64 148 65.7909 148 68C148 70.2091 149.791 72 152 72H168V88C168 90.2091 169.791 92 172 92C174.209 92 176 90.2091 176 88V68C176 65.7909 174.209 64 172 64Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.875 88C85.1629 88 88 90.7624 88 94.3846V193.615C88 197.238 85.1629 200 81.875 200H30.125C26.8371 200 24 197.238 24 193.615V94.3846C24 90.7624 26.8371 88 30.125 88H81.875ZM96 94.3846C96 86.5363 89.7709 80 81.875 80H30.125C22.2291 80 16 86.5363 16 94.3846V193.615C16 201.464 22.2291 208 30.125 208H81.875C89.7709 208 96 201.464 96 193.615V94.3846ZM64.5 97.8462C64.5 95.637 62.7091 93.8462 60.5 93.8462H51.5C49.2909 93.8462 47.5 95.637 47.5 97.8462C47.5 100.055 49.2909 101.846 51.5 101.846H60.5C62.7091 101.846 64.5 100.055 64.5 97.8462ZM70.125 190.154C70.125 187.945 68.3341 186.154 66.125 186.154H45.875C43.6659 186.154 41.875 187.945 41.875 190.154C41.875 192.363 43.6659 194.154 45.875 194.154H66.125C68.3341 194.154 70.125 192.363 70.125 190.154Z",
    fill: "#2D2D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.12 132.759L70.4049 166H78L59.4355 124H52.5645L34 166H41.835L56.12 132.759Z",
    fill: "#2D2D2D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktopMobileApp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/desktop-mobile-app.2dbae4c508d509a836eff8729922ad32.svg";